import { FC } from 'react';
import classNames from 'classnames';

import {
  useFilteredSliceItemsByLocationSlug,
  useScreenWidth,
  useShowByLocationSlug,
} from '@/hooks';
import { Container } from '@/components';
import { getSlicePadding } from '@/utils';
import { ImageGallerySlice } from '@/types';
import {
  CTAButton,
  GalleryVariation,
  renderTextSlice,
} from './ImageGallery.components';

import style from './image_gallery.module.scss';

const ImageGallery: FC<ImageGallerySlice> = slice => {
  const { width } = useScreenWidth();
  const { primary, variation } = slice;
  const {
    heading,
    heading_color,
    title,
    title_color,
    description,
    description_color,
    bottom_spacing,
    effect_zoom_images,
    border_section,
    background_color,
    max_header_width,
    padding_section,
  } = primary;

  const { showContent } = useShowByLocationSlug(slice?.primary?.location_slug);
  const { filteredItems } = useFilteredSliceItemsByLocationSlug(slice?.items);

  const paddingSection = padding_section;
  const marginBottom = bottom_spacing;
  const borderTop = border_section ?? '';
  const borderBottom = border_section ?? '';
  const backgroundImage = slice?.primary?.background_image?.url;
  const backgroundStyleFixed = slice?.primary?.background_style_fixed_cover;
  const minHeight = slice?.primary?.min_heigth;
  const maxWidtHeader =
    primary?.max_header_width && width > 428
      ? `${primary?.max_header_width}px`
      : '100%';

  const getMaxWidthdescription = () => {
    if (width < 428) {
      return '100%';
    }

    if (variation === 'imageCorousel' && primary?.max_width_description) {
      return `${primary?.max_width_description}px`;
    }

    const maxWidth = max_header_width ? `${max_header_width}px` : '100%';

    return maxWidth;
  };

  if (!showContent || !filteredItems?.length || !slice?.primary?.active) {
    return null;
  }

  return (
    <section
      className={classNames(
        style.image_gallery,
        getSlicePadding(paddingSection),
        {
          ['spacing_bottom']: marginBottom,
          ['background__fixed_cover']: backgroundStyleFixed,
          ['background__contained']: !backgroundStyleFixed,
        },
      )}
      style={{
        backgroundColor: background_color ?? '',
        borderTop,
        borderBottom,
        backgroundImage: backgroundImage
          ? `url(${backgroundImage})`
          : undefined,
        minHeight: `${minHeight || 0}vh`,
      }}
    >
      <Container
        className={classNames(style.image_gallery_container, {
          [style.carousel_container]: variation === 'imageCorousel',
          [style.container__effect_img]: effect_zoom_images,
        })}
      >
        {renderTextSlice(heading, heading_color ?? '', maxWidtHeader, false)}
        {renderTextSlice(
          title,
          title_color ?? '',
          maxWidtHeader,
          variation === 'imageGridWithCustomWidth',
        )}
        {renderTextSlice(
          description,
          description_color ?? '',
          getMaxWidthdescription(),
          true,
        )}
        <GalleryVariation slice={{ ...slice, items: filteredItems as any }} />
        <CTAButton {...slice} />
      </Container>
    </section>
  );
};

export { ImageGallery };
